import MDinput from '@/components/MDinput';
import InputNumber from '@/components/DSE/InputNumber';
import PickRec from '@/components/DSE/PickRec/src/PickRec';
import { validatorRequire } from '@/utils/validators';
import Switch from '@/components/DSE/Switch';

export function getFormDefinition(vue) {
  return {
    finishID: {
      type: PickRec,
      defaultValue: null,
      props: {
        caption: 'common.finish',
        valueField: 'id',
        labelField: 'finishTypeDescription',
        inputField: 'description',
        maxlength: 64,
        columns: [
          { field: 'description', label: 'common.finish' },
          { field: 'finishTypeDescription', label: 'common.finishType' }
        ],
        entity: 'Finish',
        required: true,
        usePagination: true,
        hideInput: false,
        suggest: true
      },
      rules: [{ validator: validatorRequire }]
    },
    applicableYN: {
      type: Switch,
      defaultValue: true,
      props: {
        caption: 'domain.productGroupFinishApplicable',
        activeText: 'common.yes',
        inactiveText: 'common.no'
      }
    },
    quantityFormula: {
      type: MDinput,
      defaultValue: null,
      dynamicProps: (form, comp) => ({
        visible: vue.showQuantityFormula()
      }),
      props: {
        maxlength: 255,
        caption: 'finish.quantityFormula'
      }
    },
    extraFabricHeightFormula: {
      type: MDinput,
      defaultValue: null,
      dynamicProps: (form, comp) => ({
        visible: vue.isExtraFabricHeightApplicable()
      }),
      props: {
        maxlength: 255,
        caption: 'finish.extraFabricHeightFormula'
      }
    },
    extraFabricWidthFormula: {
      type: MDinput,
      defaultValue: null,
      dynamicProps: (form, comp) => ({
        visible: vue.isExtraFabricWidthApplicable()
      }),
      props: {
        maxlength: 255,
        caption: 'finish.extraFabricWidthFormula'
      }
    },
    fabricWidthFactor: {
      type: InputNumber,
      defaultValue: null,
      dynamicProps: form => {
        return {
          visible: vue.isFabricWidthFactorRequired()
        };
      },
      props: {
        caption: 'finish.fabricWidthFactor',
        precision: 2,
        step: 0.05
      }
    },
    minimumFabricWidthFactor: {
      type: InputNumber,
      defaultValue: null,
      dynamicProps: form => {
        return {
          visible: vue.isFabricWidthFactorRequired()
        };
      },
      props: {
        caption: 'finish.minimumFabricWidthFactor',
        precision: 2,
        step: 0.05
      }
    },
    maximumFabricWidthFactor: {
      type: InputNumber,
      defaultValue: null,
      dynamicProps: form => {
        return {
          visible: vue.isFabricWidthFactorRequired()
        };
      },
      props: {
        caption: 'finish.maximumFabricWidthFactor',
        precision: 2,
        step: 0.05
      }
    },
    headingHeight: {
      type: MDinput,
      defaultValue: undefined,
      dynamicProps: form => {
        return {
          visible: vue.isHeadingHeightRequired()
        };
      },
      props: {
        type: 'number',
        precision: 1,
        caption: 'finish.headingHeight'
      }
    }
  };
}

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
